@if (task(); as t) {
    @let tdc = typeDef()?.color;
    <div class="layout vertical"
        [style.--vzt-project-color]="t._color"
        [style.--vzt-project-color-bg]="'hsl(from ' + t._color + ' h s 80)'"
        [style.--vzt-priority-color]="`var(--vz-priorityColor${t.priority || 0})`"
        [style.--vzt-type-color]="tdc"
        [style.--vzt-type-color-bg]="tdc ? `hsl(from ${tdc} h s 95)` : undefined"
        [style.background-color]="tdc ? `hsl(from ${tdc} h s 95)` : undefined"
        [class.bg]="!noBorder()"
        [class.vz-task-card]="!noBorder()"
        [class.flex]="!!fixedHeight()"
        [class.vz-task-unread]="!t.flags.seen"
        [style.border-radius]="cardTpl().borderRadius">
        <vz-layout-tpl
            [class.flex]="!!fixedHeight()"
            [rootElement]="cardTpl()"
            [task]="t"
            [taskTypeDef]="typeDef()"
            [tplOptions]="options()"
            [objectsMap]="objectsMap()" />
    </div>
}
@else {
    <div class="layout center-center"
        style="border-radius: 4px; height: 100px; min-width: 200px;"
        [class.bg]="!noBorder()"
        [class.vz-task-card]="!noBorder()">
        @if (_error() || !_loading()) {
            <span class="txt-p p1">Ошибка загрузки данных задачи</span>
        }
        @else {
            <div class="loader small2"></div>
        }
    </div>
}
